import { Routes as CoreRoutes } from 'core/pages'
import SimpleItemListReading from './SimpleItemList/SimpleItemListReading'
import WithEncodingReading from './Shipping/WithEncoding/WithEncodingReading'

///////////////////////////////////////////////////////////////////////////////
// Custom & core overrides, change only this!
///////////////////////////////////////////////////////////////////////////////

const CustomDirectRoutes = {}

const CustomRoutes = {
  '/shipping/withEncoding/:opCode/reading': { component: WithEncodingReading },
  '/simple-item-list/:opCode/reading': { component: SimpleItemListReading }
}

///////////////////////////////////////////////////////////////////////////////

export const Routes = { ...CustomDirectRoutes, ...CoreRoutes, ...CustomRoutes }
// eslint-disable-next-line
export type Routes = keyof typeof Routes
